import { Capacitor } from "@capacitor/core";

export type SyncPlatform = "ios" | "android" | "web";

export type SnapshotPlatformHints = {
  permission: "granted" | "denied" | "unavailable";
  unlockCount?: number;
  captureSource?: string;
};

/** Legacy heuristic when the client does not send an explicit platform. */
export function snapshotPlatformFromHints(snapshot: SnapshotPlatformHints): SyncPlatform {
  if (snapshot.permission === "unavailable") return "web";
  // iOS-only capture sources keep platform detection correct now that iOS also
  // sends an unlockCount (activations). Without this, an iOS snapshot carrying
  // unlockCount would be misread as Android by the heuristic below.
  if (
    snapshot.captureSource === "device_activity_data_main_app"
    || snapshot.captureSource === "device_activity_report_app_group"
  ) {
    return "ios";
  }
  return snapshot.unlockCount === undefined ? "ios" : "android";
}

/** Prefer the client-reported platform; fall back to snapshot heuristics for legacy clients. */
export function resolveSyncPlatform(
  clientPlatform: SyncPlatform | undefined,
  snapshot: SnapshotPlatformHints,
): SyncPlatform {
  if (clientPlatform === "ios" || clientPlatform === "android" || clientPlatform === "web") {
    return clientPlatform;
  }
  return snapshotPlatformFromHints(snapshot);
}

export function resolveClientPlatform(): SyncPlatform {
  const platform = Capacitor.getPlatform();
  if (platform === "ios" || platform === "android") return platform;
  return "web";
}
